import { mixed, object } from 'yup'

import {
  PRODUCTIVITY_FIELD,
  SICKNESS_ABSENCE_FIELD,
  TURNOVER_FIELD,
  NO_PRIORITY_FIELD,
} from './model'

export const getSchema = () =>
  object().shape({
    [NO_PRIORITY_FIELD]: mixed<boolean | string>(),
    [SICKNESS_ABSENCE_FIELD]: mixed<boolean | string>(),
    [PRODUCTIVITY_FIELD]: mixed<boolean | string>(),
    [TURNOVER_FIELD]: mixed<boolean | string>(),
  })
